window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    var instance = new Swiper('.slideshow__image-carousel.swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.slideshow__image-carousel.swiper .swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}">
    <span class="progress-thumb"></span>
  </span>`;
        },
      },

      on: {
        autoplay: function (swiper) {
          swiper.pagination.bullets.forEach(function (bullet) {
            bullet.style.setProperty('--swiper-pagination-progress', 0);
          });
        },

        autoplayTimeLeft: function (swiper, timeLeft, percentage) {
          let activeBullet = swiper.pagination.bullets.filter(
            function (bullet) {
              return bullet.classList.contains(
                'swiper-pagination-bullet-active',
              );
            },
          );

          if (!activeBullet.length) return;

          activeBullet[0].style.setProperty(
            '--swiper-pagination-progress',
            100 - percentage * 100,
          );
        },
      },
    });
  });
});
